{
  "post-office.fabric-editor.confluence-agent-content-suggestions.notification-drawer.shared": [
    {
      "type": 1,
      "value": "agentName"
    },
    {
      "type": 0,
      "value": " shared "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " suggestion"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " suggestions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " with you"
    }
  ],
  "post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-body": [
    {
      "type": 0,
      "value": "Mention an agent to instantly brainstorm ideas, draft content, and analyze data."
    }
  ],
  "post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-headline": [
    {
      "type": 0,
      "value": "Your agents are ready to help"
    }
  ],
  "post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-primary-action": [
    {
      "type": 0,
      "value": "Got it"
    }
  ]
}